import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

import {
	MeterStatusThreshold,
	MeterStatusThresholdDraft,
} from "../models/MeterStatusThreshold";

export const getMeterStatusThresholds = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[USG].[GetMeterStatusThresholds]",
		[],
		signal,
	);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []) as MeterStatusThreshold[];
		return rows.map((row) => ({
			...row,
			Threshold: Number(row.Threshold),
		}));
	}
	throw new Error(resp.message || "Error fetching meter status thresholds");
};

export const upsertMeterStatusThresholds = async (
	rows: MeterStatusThresholdDraft[],
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{
			name: "Rows",
			value: JSON.stringify(
				rows.map(({ Metric, Level, Threshold }) => ({
					Metric,
					Level,
					Threshold,
				})),
			),
		},
	];

	const resp = await apiService.callV2(
		"[USG].[UpsertMeterStatusThresholds]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving meter status thresholds");
	}
};
